import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PropertyCard from '../components/PropertyCard';
import { propertiesApi } from '../services/api';
import SEO from '../components/SEO';

const ForSalePage = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProperties();
  }, []);

  const loadProperties = async () => {
    try {
      const data = await propertiesApi.getAll();
      // Show both "en_vente" and "reserve" on the For Sale page
      setProperties(data.filter(p => p.status === 'en_vente' || p.status === 'reserve'));
    } catch (error) {
      console.error('Error loading properties:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <SEO 
        title="Biens à vendre | Maisons et appartements - Pam Immobilier"
        description="Consultez nos biens immobiliers à vendre en Suisse romande. Maisons, appartements et propriétés sélectionnés avec soin."
      />
      <Header />
      <main>
        {/* Hero Section - Clean gradient banner */}
        <section className="relative bg-gradient-to-br from-[#8B2942] via-[#A13350] to-[#722338] overflow-hidden mt-32" style={{ height: '120px' }}>
          <div className="absolute inset-0 flex items-center z-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <h1 className="text-2xl md:text-3xl font-bold text-white">
                Biens à vendre
              </h1>
            </div>
          </div>
        </section>

        {/* Properties Grid */}
        <section className="py-16 bg-stone-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {loading ? (
              <div className="flex justify-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8B2942]"></div>
              </div>
            ) : properties.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {properties.map((property, index) => (
                  <PropertyCard key={property.id} property={property} index={index} showStatus={property.status === 'reserve'} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-xl text-gray-600">
                  Aucun bien disponible pour le moment. Revenez bientôt !
                </p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ForSalePage;
